export function isAgentDirectConversation(directConversation: {totalMemberCount: number}): boolean {
  return directConversation.totalMemberCount === 1
}
